export const EventBus = document.body;

export const EventTypes = Object.freeze({
  ALL_COMPONENTS_READY: 'ALL_COMPONENTS_READY',
  MY_CUSTOM_EVENT: 'MY_CUSTOM_EVENT'
})
